import restApi from "@plannel/services/utils/rest-api";

/*
 * PSI Balance(수급 불균형 진단) 데이터 서비스.
 * 독립 DW 기반 백엔드 조회 — 목업 없음, 전부 실데이터.
 *   백엔드: GET /api/dashboard-dw/psi-balance (PsiBalanceDashboardController)
 *   소스: z_fact_rp_replenishment 단일 fact (dest 축으로 접은 뒤 eoh vs target 편차)
 *   산식·설계 근거: saas-application/docs/sql/dw/dashboard-spec/07_psi_balance.md
 *
 * params: { currentDate?, itemLevel? }
 *   ★ currentDate 는 규약상 받지만 이 화면은 쓰지 않는다 — 집계 창이 달력이 아니라
 *     fact 의 실제 **계획 지평**이다(명세 §0).
 *
 * 응답 envelope: { currencyCd, period, itemLevels, itemLevel, itemGrouped,
 *                  kpis:{ imbalance:{absPct,netPct,hiddenMultiple}, over, short, transship },
 *                  matrix:{ locations[], items[], cells[{loc,item,net}] },
 *                  topImbalance[], transshipment[{...,byLoc[]}] }
 *
 * 🚨 집계는 **계획 지평 누적**이다(단일 시점 스냅샷 아님). RP 엔진이 미래로 갈수록 목표를 채워
 *    계획 후반 스냅샷은 과잉만 남고 부족이 0 이 된다 — 그러면 재배치 카드가 통째로 빈다(명세 §0-1).
 * 🚨 matrix.cells 는 **인덱스 참조**다(locations/items 배열의 위치). 없는 조합은 생략되며,
 *    이는 "0"(목표에 정확히 맞음)과 구분된다.
 */
const get = (params) => restApi.get("/api/dashboard-dw/psi-balance", { params });

const psiBalanceService = { get };

export default psiBalanceService;
